import jMoment from 'moment-jalaali';
import { TableItemActionsNew } from '../../../../components';
export const REQUEST_STATUSES = {
  CLIENT_API_KEY_STATUS_REQUESTED: 'در انتظار تایید',
  CLIENT_API_KEY_STATUS_CONFIRMED: 'تایید شده',
  CLIENT_API_KEY_STATUS_CANCELED: 'لغو شده',
  CLIENT_API_KEY_STATUS_REVOKED: 'رد شده',
};

const columns = (onDeleteReq, copyItem) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه درخواست',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام سرویس درخواستی',
    field: 'name',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.product?.name ?? '-',
  },
  {
    title: 'کسب‌وکار سرویس‌دهنده',
    field: 'business',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.business?.name ?? '-',
  },
  {
    title: 'تاریخ ایجاد درخواست',
    field: 'creationDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.creationDate).format('dddd, jD jMMMM jYYYY'),
  },
  {
    title: 'وضعیت',
    field: 'statusCode',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '10%',
    },
    headerStyle: {
      width: '10%',
    },
    render: (rd) => REQUEST_STATUSES?.[rd?.statusCode] ?? '-',
  },

  {
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'لغو درخواست',
            isShow: true,
            onClick: () => { onDeleteReq(rowData) },
            disabled: rowData.statusCode !== 'CLIENT_API_KEY_STATUS_CONFIRMED',
          },
          {
            title: 'کپی کردن Client ID',
            isShow: true,
            disabled: !rowData?.clientId,
            onClick: () => {
              if (rowData?.clientId) {
                copyItem(rowData.clientId, 'مقدار Client ID');
              }
            },
          },
        ]}
      />
    ),

  },
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
